/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CreateTeamMemberResult
 */
export interface CreateTeamMemberResult {
  /**
   *
   * @type {string}
   * @memberof CreateTeamMemberResult
   */
  teamMemberId: string;
}

/**
 * Check if a given object implements the CreateTeamMemberResult interface.
 */
export function instanceOfCreateTeamMemberResult(
  value: object,
): value is CreateTeamMemberResult {
  if (!("teamMemberId" in value) || value["teamMemberId"] === undefined)
    return false;
  return true;
}

export function CreateTeamMemberResultFromJSON(
  json: any,
): CreateTeamMemberResult {
  return CreateTeamMemberResultFromJSONTyped(json, false);
}

export function CreateTeamMemberResultFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CreateTeamMemberResult {
  if (json == null) {
    return json;
  }
  return {
    teamMemberId: json["teamMemberId"],
  };
}

export function CreateTeamMemberResultToJSON(
  json: any,
): CreateTeamMemberResult {
  return CreateTeamMemberResultToJSONTyped(json, false);
}

export function CreateTeamMemberResultToJSONTyped(
  value?: CreateTeamMemberResult | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    teamMemberId: value["teamMemberId"],
  };
}
